var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSorting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95842 9.66634C7.95842 10.0115 7.67859 10.2913 7.33342 10.2913H0.666748C0.32157 10.2913 0.041748 10.0115 0.041748 9.66634C0.041748 9.32116 0.32157 9.04134 0.666748 9.04134H7.33342C7.67859 9.04134 7.95842 9.32116 7.95842 9.66634Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29175 6.33301C6.29175 6.67819 6.01193 6.95801 5.66675 6.95801H0.666748C0.32157 6.95801 0.041748 6.67819 0.041748 6.33301C0.041748 5.98783 0.32157 5.70801 0.666748 5.70801H5.66675C6.01193 5.70801 6.29175 5.98783 6.29175 6.33301Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62508 2.99967C4.62508 3.34485 4.34526 3.62467 4.00008 3.62467H0.666748C0.32157 3.62467 0.041748 3.34485 0.041748 2.99967C0.041748 2.6545 0.32157 2.37467 0.666748 2.37467H4.00008C4.34526 2.37467 4.62508 2.6545 4.62508 2.99967Z",
    fill: "#656579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62508 12.9997C9.62508 13.3449 9.34526 13.6247 9.00008 13.6247H0.666748C0.32157 13.6247 0.041748 13.3449 0.041748 12.9997C0.041748 12.6545 0.32157 12.3747 0.666748 12.3747H9.00008C9.34526 12.3747 9.62508 12.6545 9.62508 12.9997Z",
    fill: "#656579"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3915 0.891066C14.6356 0.646988 15.0313 0.646988 15.2754 0.891066L17.7754 3.39107C18.0194 3.63514 18.0194 4.03087 17.7754 4.27495C17.5313 4.51903 17.1356 4.51903 16.8915 4.27495L15.4584 2.84189V13.1575L16.8915 11.7244C17.1356 11.4803 17.5313 11.4803 17.7754 11.7244C18.0194 11.9685 18.0194 12.3642 17.7754 12.6083L15.2754 15.1083C15.0313 15.3524 14.6356 15.3524 14.3915 15.1083L11.8915 12.6083C11.6474 12.3642 11.6474 11.9685 11.8915 11.7244C12.1356 11.4803 12.5313 11.4803 12.7754 11.7244L14.2084 13.1575V2.84189L12.7754 4.27495C12.5313 4.51903 12.1356 4.51903 11.8915 4.27495C11.6474 4.03087 11.6474 3.63514 11.8915 3.39107L14.3915 0.891066Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorting);
export default __webpack_public_path__ + "static/media/sorting.a097aed5febd344d28bb0ee793d85f24.svg";
export { ForwardRef as ReactComponent };